import React from 'react'
import { usePipeline } from '@morningtrain/react-helpers'
import { useForm } from '../hooks'

function TriggerPipelineOnFormStartSubmit () {
  const pipeline = usePipeline()
  const form = useForm()

  const handleOnSubmit = (data) => {
    const payload = { data }

    pipeline.trigger(payload)
      .catch((err) => console.log('caught error', err))
  }

  React.useEffect(() => {
    form.onStartSubmit(handleOnSubmit)

    return () => {
      form.removeOnStartSubmitListener(handleOnSubmit)
    }
  })

  return null
}

export default TriggerPipelineOnFormStartSubmit
